/**
 * 003 — confidence badge of a match suggestion (FR-012, FR-UI-001). The level
 * is always written out ("hoch" / "mittel" / "niedrig"); colour only supports it.
 */
import { StatusBadge, type StatusTone } from '../ui';
import type { SuggestionLevel } from '../../lib/bank-api';

const TONES: Record<SuggestionLevel, StatusTone> = {
  hoch: 'success',
  mittel: 'info',
  niedrig: 'neutral',
};

export function SuggestionBadge({ level }: { level: SuggestionLevel }) {
  return (
    <StatusBadge tone={TONES[level]} title={`Konfidenz: ${level}`} data-testid="suggestion-badge">
      {level}
    </StatusBadge>
  );
}
